<template>
    <v-container class="inner-main pt-2 mb-10">
        <div class="pt-2">
            <h3 class="dialog-title">{{$t('shop.profile.gallery.heading')}}</h3>
        </div>
        <v-divider></v-divider>
        <v-row>
            <v-col sm="12" lg="7">
                <p v-html="$t('shop.profile.gallery.text')"></p>
                <p v-html="$t('shop.profile.gallery.guide')"></p>
            </v-col>
        </v-row>
        <v-row align="start">
            <v-col cols="12" md="7" lg="7" class="" order="1" order-lg="1">
                <!-- cropper doku: https://advanced-cropper.github.io/vue-advanced-cropper/guides/recipes.html#getting-the-result -->
                <cropper :aspectRatio="16 / 9" ref="cropper" class="cropper" :src="selectedImage.src"
                    v-if="selectedImage.src" :stencil-props="{
                        aspectRatio: 16 / 9,
                        movable: true,
                        resizable: true
                    }" />
                <v-sheet width="100%" height="488px" color="#e4e4e4" class="pa-8" v-else>
                </v-sheet>
                <v-row class="mt-3">
                    <v-col align-self="end">
                        <v-btn size="large" variant="flat" color="default" rounded="xl" @click="triggerFileSelect"
                            v-if="!selectedImage.src">{{$t('entity.action.chooseGalleryImage')}}</v-btn>
                        <v-btn size="large" variant="flat" color="default" rounded="xl" @click="resetImage"
                            v-else>{{$t('entity.action.cancel')}}</v-btn>
                        <!-- Hidden file input -->
                        <input type="file" accept="image/*" ref="fileInput" style="display: none;"
                            @change="handleFileChange" />
                    </v-col>
                </v-row>
                <v-row class="mt-1" justify="between">
                    <v-col align-self="end">
                        <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-plus"
                            color="primary" @click="addImage">{{$t('entity.action.upload')}}</v-btn>
                    </v-col>
                    <v-col class="text-right">
                        <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large"
                            prepend-icon="mdi-content-save" color="primary"
                            @click="$router.push({ path: '/shop/profile', query: { editMode: true } })">{{$t('entity.action.save')}}</v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" md="5" lg="5" order="3" order-lg="2">
                <v-sheet class="w-100 h-100 py-3 px-4" color="default">
                    <p v-html="$t('shop.profile.gallery.sample')"></p>
                    <v-row align="center" dense>
                        <v-col cols="6">
                            <v-img src="/images/gallery/samples/sample-0.jpg"></v-img>
                        </v-col>
                        <v-col cols="6">
                            <v-img src="/images/gallery/samples/sample-1.jpg"></v-img>
                        </v-col>
                        <v-col cols="6">
                            <v-img src="/images/gallery/samples/sample-2.jpg"></v-img>
                        </v-col>
                        <v-col cols="6">
                            <v-img src="/images/gallery/samples/sample-3.jpg"></v-img>
                        </v-col>
                        <v-col cols="6">
                            <v-img src="/images/gallery/samples/sample-4.jpg"></v-img>
                        </v-col>
                        <v-col cols="6">
                            <v-img src="/images/gallery/samples/sample-5.jpg"></v-img>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-col>
            <v-col cols="12" lg="12" order="2" order-lg="3">
                <v-item-group mandatory v-model="preview">
                    <v-row>
                        <!-- TODO DRAG AND DROP -->
                        <v-col md="3" lg="3" v-for="(image, index) in shop?.gallerieAssets" :key="index">
                            <v-item v-slot="{ isSelected, toggle }">
                                <v-card :color="isSelected ? 'primary' : ''" variant="flat" @click="toggle">
                                    <v-card-item>
                                        {{ index == 0 ? $t('global.form.new-product.first-image') : $t('global.form.new-product.image',{index: index +1})}}

                                        <template v-slot:append>
                                            <v-icon color="error" @click.stop="() => removeImage(image)">
                                                mdi-trash-can
                                            </v-icon>
                                        </template>
                                    </v-card-item>
                                    <v-card-text>
                                        <v-img :src="`${$cloudFrontApi}${image}/GALLERY_IPHONE6`"></v-img>
                                    </v-card-text>
                                </v-card>

                            </v-item>
                        </v-col>
                    </v-row>
                </v-item-group>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import { getCurrentInstance, inject, ref } from 'vue';
import { CircleStencil, Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
    components: {
        Cropper, CircleStencil
    },

    mounted(){
        const tourOverlay = document.querySelector('.v-tour__overlay');
        if (tourOverlay) {
            tourOverlay.remove();
        }
    },

    data() {
        return {
            tab: 'Lieblingsmarken',
            preview: 0,
        }
    },
    methods: {
        getCroppedData() {
            const { coordinates, canvas, } = this.$refs.cropper.getResult();
            return { coordinates, canvas, }
        }
    },
    setup() {

        const input = ref("");
        const shop = inject('shop');
        const fetchOwnShop = inject('fetchOwnShop');
        const { proxy } = getCurrentInstance();
        if (shop == null) {
            fetchOwnShop();
        }
        const fileInput = ref(null);

        const selectedImage = ref({
            src: null,
            width: 80,
            height: 80,
            transforms: {
                rotate: 15,
                flip: {
                    horizontal: true,
                    vertical: false,
                },
            },
        });
        const hardToken = localStorage.getItem("hardToken");
        const username = localStorage.getItem("username");
        const softToken = localStorage.getItem("softToken");
        const resetImage = () => {
            selectedImage.value = {
                src: null,
                width: 80,
                height: 80,
                transforms: {
                    rotate: 15,
                    flip: {
                        horizontal: true,
                        vertical: false,
                    },
                },
            }
        }

        // Trigger the hidden file input
        const triggerFileSelect = () => {
            fileInput.value.click();
        };
        const image = ref(null)

        const saveableLogo = ref(null)
        const cropImage = () => {
            saveableLogo.value = proxy.getCroppedData()
            image.value = saveableLogo.value.canvas.toDataURL();
            resetImage();
        }

        // Handle the file selection
        const saveableFile = ref(null);
        const handleFileChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                saveableFile.value = file;
                const reader = new FileReader();
                reader.onload = (e) => {
                    const image = new Image();
                    image.onload = () => {
                        selectedImage.value.src = e.target.result; // Set the base64 data URL
                        // selectedImage.value.width = 'auto'; // Get the image width
                        // selectedImage.value.height = 488; // Get the image height
                    };
                    image.src = e.target.result;
                };
                reader.readAsDataURL(file);
            }
            fileInput.value.value = '';
        };

        const convertToBlob = async (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onloadend = () => {
                    const blob = new Blob([reader.result], { type: file.type });
                    resolve(blob);
                };
                reader.onerror = (error) => reject(error);
            });
        };

        const removeImage = async (id) => {
            try {
                const response = await proxy.$axios.delete(`/image/shop/${id}`, {
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-SOFTTOKEN': softToken,
                        'X-Auth-USER': username
                    },
                });
            } catch (error) {
                console.error("Error deleting Obj:", error);
            } finally {
                fetchOwnShop();
            }
        }
        const addImage = async () => {
            cropImage();
            // /api/image/shop
            if (!saveableFile.value) {
                console.error("No file selected.");
                return;
            }
            const logoObj = {
                file: saveableFile.value,
                x: saveableLogo.value.coordinates.left,
                y: saveableLogo.value.coordinates.top,
                height: saveableLogo.value.coordinates.height,
                width: saveableLogo.value.coordinates.width
            }
            try {
                const blobFile = await convertToBlob(saveableFile.value);

                const formData = new FormData();
                formData.append("file", blobFile);
                formData.append("x", logoObj.x);
                formData.append("y", logoObj.y);
                formData.append("height", logoObj.height);
                formData.append("width", logoObj.width);

                const response = await fetch(process.env.VUE_APP_API_BASE_URL + '/image/shop', {
                    method: "POST",
                    body: formData, // Don't manually set headers
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-SOFTTOKEN': softToken,
                        'X-Auth-USER': username
                    },
                });

                // if (response.data.status == 'OK') {
                // }

            } catch (error) {
                console.error("Error uploading image:", error);
            } finally {
                fetchOwnShop();
                // loading.value = false;
            }
        }

        

        return {
            input,
            fileInput,
            selectedImage,
            triggerFileSelect,
            handleFileChange,
            cropImage,
            shop,
            addImage,
            removeImage
            // resetImage
        };
    },
};
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
}

.v-tab-selected {
    text-decoration: underline;
}

.v-tab {
    font-size: 26px;
    font-weight: 800;
    font-family: Montserrat, sans-serif;
    letter-spacing: normal;
}

.v-btn.find-favourites-button {
    font-size: 14px;
    font-weight: 400;
}

a {
    text-decoration: none;
}
</style>